var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoRecords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 203,
    viewBox: "0 0 229 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2759:4080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.5 130C61.2045 130 18 173.428 18 227H211C211 173.428 167.795 130 114.5 130Z",
    fill: "url(#paint0_linear_2759:4080)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.901 46.7777C116.706 47.5645 125.136 48.984 132.432 45.721C139.727 42.458 143.187 38.2961 144.504 36.9539",
    stroke: "#E6E8EC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.551 28.2059C113.355 28.9927 121.786 30.4122 129.081 27.1492C136.376 23.8862 139.836 19.7243 141.154 18.3821",
    stroke: "#E6E8EC",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6822 58.2375C87.1053 58.4255 80.6502 54.1808 78.2448 52.0349C82.1499 51.3343 84.8985 50.5305 87.8476 47.6341C89.8319 45.6853 94.2354 42.1265 97.6358 43.1449C100.356 43.9595 102.281 46.4532 102.903 47.5982L106.145 45.2313L107.595 46.3608C105.754 47.528 101.371 50.1325 98.5722 51.2134C95.7729 52.2943 90.2313 53.2967 87.8104 53.6628C89.1751 53.7553 92.5091 53.852 94.9273 53.4994C97.3455 53.1467 101.863 51.5251 103.819 50.7583C103.932 51.3119 104.09 52.6236 103.825 53.4422C103.494 54.4655 101.903 58.0024 93.6822 58.2375Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4896 140.32H146.444C149.476 140.32 151.934 142.79 151.934 145.836V160.462C151.934 163.509 149.476 165.978 146.444 165.978H88.4896C85.4578 165.978 83 163.509 83 160.462V145.836C83 142.79 85.4578 140.32 88.4896 140.32Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.33 145.632H144.264C145.003 145.632 145.602 146.234 145.602 146.977C145.602 147.719 145.003 148.321 144.264 148.321H108.33C107.591 148.321 106.992 147.719 106.992 146.977C106.992 146.234 107.591 145.632 108.33 145.632Z",
    fill: "#E1E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.33 150.534H134.089C134.829 150.534 135.428 151.136 135.428 151.879C135.428 152.622 134.829 153.224 134.089 153.224H108.33C107.591 153.224 106.992 152.622 106.992 151.879C106.992 151.136 107.591 150.534 108.33 150.534Z",
    fill: "#E1E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.33 157.888H116.695C117.434 157.888 118.033 158.49 118.033 159.233C118.033 159.976 117.434 160.578 116.695 160.578H108.33C107.591 160.578 106.992 159.976 106.992 159.233C106.992 158.49 107.591 157.888 108.33 157.888Z",
    fill: "#E1E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3663 156.141C98.8274 156.141 101.633 153.331 101.633 149.865C101.633 146.399 98.8274 143.589 95.3663 143.589C91.9053 143.589 89.0996 146.399 89.0996 149.865C89.0996 153.331 91.9053 156.141 95.3663 156.141Z",
    fill: "#E1E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4896 110.496H146.444C149.476 110.496 151.934 112.965 151.934 116.012V130.638C151.934 133.684 149.476 136.154 146.444 136.154H88.4896C85.4578 136.154 83 133.684 83 130.638V116.012C83 112.965 85.4578 110.496 88.4896 110.496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.33 115.808H144.264C145.003 115.808 145.602 116.41 145.602 117.152C145.602 117.895 145.003 118.497 144.264 118.497H108.33C107.591 118.497 106.992 117.895 106.992 117.152C106.992 116.41 107.591 115.808 108.33 115.808Z",
    fill: "#E1E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.33 120.71H134.089C134.829 120.71 135.428 121.312 135.428 122.055C135.428 122.798 134.829 123.4 134.089 123.4H108.33C107.591 123.4 106.992 122.798 106.992 122.055C106.992 121.312 107.591 120.71 108.33 120.71Z",
    fill: "#E1E9F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.33 128.064H116.695C117.434 128.064 118.033 128.666 118.033 129.409C118.033 130.152 117.434 130.754 116.695 130.754H108.33C107.591 130.754 106.992 130.152 106.992 129.409C106.992 128.666 107.591 128.064 108.33 128.064Z",
    fill: "#EBF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3663 126.316C98.8274 126.316 101.633 123.507 101.633 120.04C101.633 116.574 98.8274 113.765 95.3663 113.765C91.9053 113.765 89.0996 116.574 89.0996 120.04C89.0996 123.507 91.9053 126.316 95.3663 126.316Z",
    fill: "#EBF1F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2759:4080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8963 68.0397L146.444 76.2465C149.476 76.7126 151.934 78.8414 151.934 80.9979V95.403C151.934 97.5595 149.476 99.6851 146.444 100.147L89.3029 106.242C86.2711 106.631 83 104.074 83 100.03V74.2448C83 70.2011 85.8644 67.6471 88.8963 68.0397Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.8963 68.0397L146.444 76.2465C149.476 76.7126 151.934 78.8414 151.934 80.9979V95.403C151.934 97.5595 149.476 99.6851 146.444 100.147L89.3029 106.242C86.2711 106.631 83 104.074 83 100.03V74.2448C83 70.2011 85.8644 67.6471 88.8963 68.0397Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.33 79.8L144.264 82.3103C145.003 82.3646 145.602 82.8721 145.602 83.4439C145.602 84.0157 145.003 84.4509 144.264 84.4158L108.33 82.7957C107.591 82.7641 106.992 82.0608 106.992 81.2249C106.992 80.3889 107.591 79.751 108.33 79.8Z",
    fill: "#EBF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.33 85.2601L134.089 85.8876C134.829 85.9063 135.428 86.4436 135.428 87.0877C135.428 87.7318 134.829 88.254 134.089 88.2541L108.33 88.2558C107.591 88.2559 106.992 87.5782 106.992 86.7423C106.992 85.9064 107.591 85.2427 108.33 85.2601Z",
    fill: "#EBF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.33 93.4514L116.695 93.1052C117.434 93.0742 118.033 93.6677 118.033 94.431C118.033 95.1943 117.434 95.8527 116.695 95.9015L108.33 96.4471C107.591 96.4947 106.992 95.8556 106.992 95.0196C106.992 94.1837 107.591 93.4816 108.33 93.4514Z",
    fill: "#EBF1F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2437 91.8344C100.189 91.7509 103.388 88.3825 103.388 84.3118C103.388 80.241 100.189 76.7151 96.2437 76.4392C92.2981 76.1668 89.0996 79.5378 89.0996 83.9657C89.0996 88.3935 92.2981 91.9169 96.2437 91.8344Z",
    fill: "#EBF1F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2759:4080",
    x: 48,
    y: 52,
    width: 138.934,
    height: 108.281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.189057 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2759:4080"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2759:4080",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2759:4080",
    x1: 114.5,
    y1: 130,
    x2: 114.5,
    y2: 227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5EFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477843,
    stopColor: "#E5EFF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2759:4080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 203,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecords);
export default __webpack_public_path__ + "static/media/no-records.6b0e7ce4.svg";
export { ForwardRef as ReactComponent };